import { products, WeatherSettingsChangeSource, WeatherTimelineSyncMode } from '@fe/weather';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import React from 'react';
import useSelectedWeather from '../../hooks/use-selected-weather';
import {
    AnimationTimePauseBetweenCycles,
    AnimationTimeToShowEachSlide,
    TimelineSyncMode,
    TimelineTimeMode,
    TimelineTimeRange
} from '../settings-options';
import { useDropdownSetting, useNumericSetting } from './hooks/useSetting';

export default function AnimationSettings() {
    const selectedWeather = useSelectedWeather();
    const changeSource = WeatherSettingsChangeSource.animation;
    const timeToShowEachSlide = useDropdownSetting(AnimationTimeToShowEachSlide, 'animation', 'timeToShowSlideSeconds', changeSource);
    const numberOfSlides = useNumericSetting('animation', 'numberOfSlides', changeSource);
    const pauseBetweenCycles = useDropdownSetting(AnimationTimePauseBetweenCycles, 'animation', 'pauseBetweenCyclesSeconds', changeSource);
    const syncMode = useDropdownSetting(TimelineSyncMode, 'animation', 'timelineSyncMode', changeSource);
    const timeRange = useDropdownSetting(TimelineTimeRange, 'animation', 'timelineTimeRange', changeSource);
    const timeMode = useDropdownSetting(TimelineTimeMode, 'animation', 'timelineTimeMode', changeSource);

    const customLayersOptions = React.useMemo(
        () => selectedWeather.map((x) => ({ value: x.id, text: products[x.id]?.name })),
        [selectedWeather]
    );
    const customLayerSync = useDropdownSetting(customLayersOptions, 'animation', 'timelineSyncCustomProduct', changeSource);

    return (
        <div className="d-flex gap-2 flex-column">
            <div>
                <div>Time to show each slide</div>
                <DropDownList {...timeToShowEachSlide} />
            </div>

            <div>
                <div>Number of slides</div>
                <NumericTextBox min={1} max={16} {...numberOfSlides} />
            </div>

            <div>
                <div>Pause between cycles</div>
                <DropDownList {...pauseBetweenCycles} />
            </div>

            <div>
                <div>Sync to layer:</div>
                <DropDownList {...syncMode} />
            </div>
            {syncMode.value.value === WeatherTimelineSyncMode.custom && (
                <div>
                    <div>Custom sync layer:</div>
                    <DropDownList {...customLayerSync} />
                </div>
            )}

            <div>
                <div>Legend time range</div>
                <DropDownList {...timeRange} />
            </div>

            <div>
                <div>Legend time mode</div>
                <DropDownList {...timeMode} />
            </div>
        </div>
    );
}
